// extracted by mini-css-extract-plugin
export default {"picker":"CaseSourcePicker_picker__Fw6vN","sectionLabel":"CaseSourcePicker_sectionLabel__xsQSE","tabs":"CaseSourcePicker_tabs__no0xw"};